import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { View } from '@instructure/ui-view';
import NumberInput from '@instructure/quiz-number-input';
import t from '@instructure/quiz-i18n/format-message';
var ExtraAttemptsInput = /*#__PURE__*/function (_Component) {
  function ExtraAttemptsInput() {
    var _this2;
    _classCallCheck(this, ExtraAttemptsInput);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, ExtraAttemptsInput, [].concat(args));
    _defineProperty(_this2, "getMessages", function (value, parsedValue, min, max) {
      var messages = null;
      if (parsedValue === null && value !== '') {
        messages = [{
          type: 'error',
          text: t('{userInput, string} is not a valid number.', {
            userInput: value
          })
        }];
      } else if (parsedValue < min) {
        messages = [{
          type: 'error',
          text: t('{userInput, number} is below the minimum of {min, number}.', {
            userInput: parsedValue,
            min: min
          })
        }];
      } else if (parsedValue > max) {
        messages = [{
          type: 'error',
          text: t('{userInput, number} is above the maximum of {max, number}.', {
            userInput: parsedValue,
            max: max
          })
        }];
      }
      return messages;
    });
    _defineProperty(_this2, "onChange", function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var raw = arguments.length > 1 ? arguments[1] : undefined;
      var parsedNum = arguments.length > 2 ? arguments[2] : undefined;
      var parsed = parsedNum === null ? null : Number(parsedNum);
      _this2.props.onChange(e, raw, parsed);
    });
    return _this2;
  }
  _inherits(ExtraAttemptsInput, _Component);
  return _createClass(ExtraAttemptsInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        label = _this$props.label,
        max = _this$props.max,
        min = _this$props.min,
        value = _this$props.value,
        parsedValue = _this$props.parsedValue,
        revertValue = _this$props.revertValue,
        revert = _this$props.revert,
        onBlur = _this$props.onBlur;
      var step = 1;
      var precision = 0;
      return /*#__PURE__*/React.createElement(View, {
        display: "block",
        margin: "medium none"
      }, /*#__PURE__*/React.createElement(NumberInput, {
        renderLabel: label,
        step: step,
        value: revert ? revertValue : value,
        onChange: this.onChange,
        onBlur: onBlur,
        messages: this.getMessages(value, parsedValue, min, max),
        decimalPrecision: precision,
        "data-automation": "sdk-moderation-extra-attempts"
      }));
    }
  }]);
}(Component);
_defineProperty(ExtraAttemptsInput, "propTypes", {
  label: PropTypes.string.isRequired,
  max: PropTypes.number.isRequired,
  min: PropTypes.number,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  parsedValue: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  revertValue: PropTypes.number,
  revert: PropTypes.bool
});
_defineProperty(ExtraAttemptsInput, "defaultProps", {
  min: 0,
  revert: false,
  parsedValue: null,
  revertValue: null
});
export default ExtraAttemptsInput;